
import { useLanguage } from "@/contexts/LanguageContext";
import { Label } from "@/components/ui/label";
import LocationCreativeItem from "./LocationCreativeItem";
import type { Creative, Location } from "../../types";

interface LocationCreativesProps {
  selectedLocations: Location[];
  locationCreatives: Record<string, Creative[]>;
  onLocationFileChange: (locationName: string, e: React.ChangeEvent<HTMLInputElement>, day?: number) => void;
  onRemoveLocationCreative: (locationName: string, index: number) => void;
  onUpdateLocationCreativeDays?: (locationName: string, creativeIndex: number, days: number[]) => void;
  isUploading: boolean;
}

const LocationCreatives = ({
  selectedLocations,
  locationCreatives,
  onLocationFileChange,
  onRemoveLocationCreative,
  onUpdateLocationCreativeDays,
  isUploading
}: LocationCreativesProps) => {
  const { t } = useLanguage();

  if (selectedLocations.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4 mt-4">
      <Label className="text-base font-medium">{t("locationSpecificContent")}</Label>
      <div className="space-y-4">
        {selectedLocations.map((location) => (
          <LocationCreativeItem
            key={location.name}
            location={location}
            creatives={locationCreatives[location.name] || []}
            onLocationFileChange={onLocationFileChange}
            onRemoveLocationCreative={onRemoveLocationCreative}
            onUpdateCreativeDays={onUpdateLocationCreativeDays}
            isUploading={isUploading}
          />
        ))}
      </div>
    </div>
  );
};

export default LocationCreatives;
